import React, { useEffect, useRef } from 'react';
import './input-wrapper.scss';
import { digitCounts, i18nService } from '@zonofi/i18n';

const MAX_ROWS = 4;
const LINE_HEIGHT = 20;

interface InputWrapperProps {
  icon?: string;
  placeholder: string;
  value: string;
  onChange: (value: string) => void;
  multiline?: boolean;
  type?: string;
  maxLength?: number | undefined;
}

export const InputWrapper: React.FC<InputWrapperProps> = ({
  icon,
  placeholder,
  value,
  onChange,
  multiline = false,
  type = 'text',
  maxLength = undefined,
}) => {
  const textareaRef = useRef<HTMLTextAreaElement | null>(null);

  useEffect(() => {
    if (!multiline || !textareaRef.current) return;
    const textarea = textareaRef.current;
    textarea.style.height = 'auto';

    const maxHeight = MAX_ROWS * LINE_HEIGHT;
    textarea.style.height = `${Math.min(textarea.scrollHeight, maxHeight)}px`;
  }, [value, multiline]);

  return (
    <div className="input-wrapper">
      {icon && (
        <span className="input-wrapper--icon">
          <img src={icon} width={24} height={24} />
        </span>
      )}

      {multiline ? (
        <textarea
          ref={textareaRef}
          placeholder={placeholder}
          value={value}
          rows={1}
          onChange={(e) => onChange(e.target.value)}
          className="input-wrapper--textarea font-medium"
        />
      ) : (
        <input
          type={type}
          placeholder={placeholder}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          className="input-wrapper--input font-medium"
          inputMode={type === 'number' ? 'numeric' : undefined}
          maxLength={
            maxLength ??
            (type === 'tel'
              ? digitCounts[i18nService.getCurrentCountryCode()] || 10
              : undefined)
          }
        />
      )}
    </div>
  );
};
